import { render, staticRenderFns } from "./HostelPrice.vue?vue&type=template&id=6ef0f1ba&scoped=true&"
import script from "./HostelPrice.vue?vue&type=script&lang=ts&"
export * from "./HostelPrice.vue?vue&type=script&lang=ts&"
import style0 from "./HostelPrice.vue?vue&type=style&index=0&id=6ef0f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0f1ba",
  null
  
)

export default component.exports